// removed by extract-text-webpack-plugin
module.exports = {"dialog":"EnterpriseRules__dialog___Bc780","footer":"EnterpriseRules__footer___35itW","footer--basic":"EnterpriseRules__footer--basic___r3nFU","confirmBtn":"EnterpriseRules__confirmBtn___gjfif","cancelBtn":"EnterpriseRules__cancelBtn___2XN8U"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseRules/EnterpriseRules.scss
// module id = 1023
// module chunks = 0